
import Header from '../../components/feature/Header';
import HeroSection from '../../components/feature/HeroSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <Footer />
    </div>
  );
}
